import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import IconBulletList from '../../Shared/IconBulletList/IconBulletList'
import styles from './Section.module.scss'

const Section = (props) => {
  const {
    header,
    description,
    handyNotes,
    className
  } = props

  const sectionClasses = classnames(
    styles.section,
    className
  )

  return (
    <div className={sectionClasses}>
      <h2 className={styles.sectionHeader}>
        {header}
      </h2>
      <div className={styles.sectionContent}>
        <p className={styles.sectionDescription}>
          {description}
        </p>
        { handyNotes && handyNotes.length > 0 && (
          <IconBulletList
            icon="checked"
            title="Have handy:"
            items={handyNotes} />
        )}
      </div>
    </div>
  )
}

Section.propTypes = {
  header: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  handyNotes: PropTypes.arrayOf(PropTypes.string.isRequired),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.any)])
}


Section.defaultProps = {
  handyNotes: [],
  className: ''
}

export default Section



// WEBPACK FOOTER //
// ./src/components/Onboarding/GettingStarted/v2/Section.jsx